export default __webpack_public_path__ + "static/media/Layer 2.aaba94a6.jpg";